{
  "unauthorized": {
    "errorCode": "403",
    "title": "Zugriff verweigert",
    "subtitle": "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.",
    "backToChat": "Zum Chat",
    "helpText": "Wenn Sie glauben, dass dies ein Fehler ist, kontaktieren Sie bitte Ihren Organisationsadministrator."
  },
  "missionChat": {
    "agentNotRespondingDescription": "Der Host \"{{hostName}}\" ist verbunden, aber die Agent-Laufzeit antwortet nicht. Stellen Sie sicher, dass die Agent-Anwendung auf dem Host läuft.",
    "hostOfflineDescription": "Der Agent-Host \"{{hostName}}\" ist derzeit offline.",
    "accessDenied": "Zugriff verweigert",
    "accessDeniedDescription": "Sie haben keine Berechtigung für diese Mission.",
    "agentNotResponding": "Agent antwortet nicht",
    "agentNotRespondingHint": "Prüfen Sie, ob der agion-sdk-Agent läuft und auf Port 8190 lauscht.",
    "connectionError": "Verbindungsfehler",
    "connectionErrorDescription": "Verbindung zur Mission nicht möglich.",
    "error": "Etwas ist schiefgelaufen",
    "hostNotFound": "Host nicht verfügbar",
    "hostNotFoundDescription": "Der Agent-Host dieser Mission wurde nicht gefunden.",
    "hostOffline": "Host offline",
    "hostOfflineHint": "Stellen Sie sicher, dass der Agent-Host läuft und mit dem VPN verbunden ist.",
    "loadingHost": "Verbindung zum Host wird hergestellt...",
    "notFoundDescription": "Diese Mission existiert nicht oder wurde möglicherweise gelöscht.",
    "retry": "Erneut versuchen",
    "retryConnection": "Verbindung wiederholen",
    "launching": "Wird gestartet...",
    "runMission": "Mission ausführen",
    "loading": "Mission-Chat wird geladen...",
    "notFound": "Mission nicht gefunden",
    "loadError": "Mission konnte nicht geladen werden"
  },
  "files": {
    "title": "Dateien",
    "subtitle": "Hochgeladene Dateien und Daten verwalten",
    "searchPlaceholder": "Dateien suchen...",
    "count_one": "{{count}} Datei",
    "count_other": "{{count}} Dateien",
    "loading": "Dateien werden geladen...",
    "noFilesFound": "Keine Dateien gefunden",
    "noFilesUploaded": "Keine Dateien hochgeladen",
    "adjustSearch": "Versuchen Sie, den Suchbegriff anzupassen",
    "uploadFirst": "Laden Sie Ihre erste Datei hoch, um zu beginnen",
    "deleteConfirm": "Möchten Sie diese Datei wirklich löschen?",
    "deleteSuccess": "Datei erfolgreich gelöscht",
    "fileRemoved": "Datei entfernt",
    "deleteError": "Datei konnte nicht gelöscht werden",
    "downloadError": "Datei konnte nicht heruntergeladen werden",
    "downloadSuccess": "Datei erfolgreich heruntergeladen",
    "clickToRename": "Zum Umbenennen der Datei klicken",
    "referenceHint": "Dateien mit dem Status 'abgeschlossen' können im Chat referenziert werden",
    "columnName": "Name",
    "columnSize": "Größe",
    "columnDate": "Hochgeladen",
    "columnStatus": "Status",
    "time": {
      "justNow": "Gerade eben",
      "minutesAgo": "vor {{count}} Min.",
      "hoursAgo": "vor {{count}} Std.",
      "daysAgo": "vor {{count}} Tagen"
    }
  },
  "agents": {
    "title": "Agents",
    "subtitle": "Wählen Sie einen Agent, um eine Unterhaltung zu starten",
    "searchPlaceholder": "Agents nach Name, Modell oder Fähigkeit suchen...",
    "count_one": "{{count}} Agent verfügbar",
    "count_other": "{{count}} Agents verfügbar",
    "loading": "Agents werden geladen...",
    "error": "Agents konnten nicht geladen werden",
    "noAgentsFound": "Keine Agents gefunden",
    "noAgentsAvailable": "Keine Agents verfügbar",
    "adjustSearch": "Versuchen Sie, den Suchbegriff anzupassen",
    "noAgentsConfigured": "Derzeit sind keine KI-Agents konfiguriert",
    "clickToChat": "Klicken Sie auf einen Agent, um eine Unterhaltung zu starten..."
  },
  "profile": {
    "title": "Profil",
    "subtitle": "Kontoeinstellungen und Präferenzen verwalten",
    "loading": "Profil wird geladen...",
    "updateSuccess": "Profil erfolgreich aktualisiert!",
    "firstName": "Vorname",
    "firstNamePlaceholder": "Vorname eingeben",
    "lastName": "Nachname",
    "lastNamePlaceholder": "Nachname eingeben",
    "email": "E-Mail",
    "emailReadonly": "E-Mail kann nicht geändert werden",
    "emailCannotChange": "E-Mail kann nicht geändert werden. Kontaktieren Sie den Support, falls Sie dies aktualisieren möchten.",
    "connectedVia": "Verbunden über {{provider}}",
    "notSet": "Nicht gesetzt",
    "changePassword": "Passwort ändern",
    "currentPassword": "Aktuelles Passwort",
    "currentPasswordPlaceholder": "Aktuelles Passwort eingeben",
    "newPassword": "Neues Passwort",
    "newPasswordPlaceholder": "Neues Passwort eingeben",
    "newPasswordHint": "Mindestens 8 Zeichen mit Groß- und Kleinbuchstaben, Zahl und Sonderzeichen",
    "confirmPassword": "Neues Passwort bestätigen",
    "confirmPasswordPlaceholder": "Neues Passwort bestätigen",
    "changingPassword": "Passwort wird geändert...",
    "passwordSuccess": "Passwort erfolgreich geändert!",
    "passwordMismatch": "Die neuen Passwörter stimmen nicht überein",
    "passwordError": "Passwort konnte nicht geändert werden",
    "edit": "Bearbeiten",
    "saveError": "Änderungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.",
    "defaultOrganization": "Agion Platform",
    "validation": {
      "minLength": "Passwort muss mindestens 8 Zeichen lang sein",
      "complexity": "Passwort muss mindestens eine Zahl oder ein Sonderzeichen enthalten"
    },
    "providers": {
      "google": "Google",
      "microsoft": "Microsoft",
      "email": "E-Mail & Passwort",
      "agion": "Agion"
    }
  },
  "nextPages": {
    "aboutSection": "Über {{subject}}",
    "files": {
      "actions": "Aktionen",
      "deleteTitle": "{{name}} löschen?",
      "loadError": "Ihre Dateien konnten nicht geladen werden",
      "loadErrorBody": "Ihre Dateien konnten nicht gelesen werden. Versuchen Sie es gleich noch einmal.",
      "emptyTitle": "Noch keine Dateien",
      "emptyBody": "Dateien, die Sie einem Missionslauf anhängen, erscheinen hier.",
      "moreActionsFor": "Weitere Aktionen für {{name}}"
    },
    "profile": {
      "youTitle": "Sie",
      "youInfo": "Ihr Name, Ihre E-Mail-Adresse und Ihre Rolle in dieser Organisation.",
      "role": "Rolle",
      "preferencesTitle": "Einstellungen",
      "preferencesInfo": "Die Sprache, die der Chat für Sie verwendet.",
      "language": "Sprache",
      "languageHint": "In Ihrem Konto gespeichert, damit Ihre Sprache Ihnen in jeden Browser folgt.",
      "languageSaveFailed": "Ihre Sprache konnte nicht gespeichert werden.",
      "passwordInfo": "Ändern Sie das Passwort, mit dem Sie sich anmelden. Sie benötigen Ihr aktuelles Passwort.",
      "showPassword": "Passwort anzeigen",
      "hidePassword": "Passwort verbergen",
      "loadError": "Ihr Profil konnte nicht geladen werden",
      "loadErrorBody": "Ihre Kontodaten konnten nicht gelesen werden. Versuchen Sie es gleich noch einmal.",
      "openedBy": {
        "title": "Wer Ihre Unterhaltungen geöffnet hat",
        "info": "Personen, die den Inhalt einer von Ihnen begonnenen Unterhaltung geöffnet oder exportiert haben, neueste zuerst.",
        "loading": "Wird geladen, wer Ihre Unterhaltungen geöffnet hat…",
        "loadError": "Wer Ihre Unterhaltungen geöffnet hat, konnte nicht geladen werden",
        "empty": "Niemand sonst hat Ihre Unterhaltungen geöffnet.",
        "showMore": "Mehr anzeigen",
        "who": "{{name}} ({{role}})",
        "formerMember": "Ein ehemaliges Mitglied",
        "unnamedMember": "Ein Mitglied Ihrer Organisation",
        "read": "{{who}} hat Ihre Unterhaltung {{mission}} am {{date}} geöffnet",
        "export": "{{who}} hat Ihre Unterhaltung {{mission}} am {{date}} exportiert"
      }
    }
  }
}
